import React, { useState, useEffect } from "react";
import { MinimalContainer } from "../../styles/Theme";
import styled from "styled-components";
import Button from "../Button";
import Input from "../Input";
import moment from "moment";
import AliquotInput from "../common/form/AliquotInput";

const Container = styled(MinimalContainer)`
  padding: 20px;
  max-width: 1920px;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const Column = styled.div`
  flex-grow: 1;
  min-width: 350px;
  padding: 0 15px;
  margin-bottom: 10px;
`;

const FullColumn = styled.div`
  width: 100%;
  padding: 0 15px;
`;

export default function BarcodeSampleTestSearch({ onSearch, clientView = false, reset }) {
  const [aliquotIds, setAliquotIds] = useState([]);
  const [sampleIds, setSampleIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(5, "years"));
  const [endDate, setEndDate] = useState(moment());

  const valid = () => {
    return aliquotIds.length > 0 || sampleIds.length > 0;
  };

  const onClick = () => {
    setLoading(true);
    valid() &&
      onSearch &&
      onSearch(
        {
          sample_ids: sampleIds,
          aliquot_ids: aliquotIds,
          start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
          end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
        },
        () => {
          setLoading(false);
        }
      );
  };

  // // useEffect(() => {
  // // if (aliquotIds.length > 0) {
  // // onClick();
  // // }
  // // }, [aliquotIds]);

  return (
    <Container>
      <Row>
        <Column>
          <AliquotInput
            key="aliquot_input"
            aliquotIds={aliquotIds}
            onAliquotChange={(aliquotIds) => {
              setAliquotIds(aliquotIds);
            }}
            onSampleChange={(sampleIds) => {
              setSampleIds(sampleIds);
            }}
            onSearch={onClick}
            onCleared={reset}
          />
        </Column>
      </Row>
      <Row>
        <FullColumn>
          <Button
            title={loading ? I18n.t("please_wait") : I18n.t("find_tests")}
            icon={loading ? "fa-spin fa-spinner" : "fa-search"}
            disabled={loading || !valid()}
            onClick={onClick}
          />
          <div className="pull-right">
            <a href="/scheduling/aliquot_scans">Show Scanning History</a>
          </div>
        </FullColumn>
      </Row>
    </Container>
  );
}
